/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const RunbookStatus = core.serialization.enum_(["CREATED", "RECORDING", "EXECUTING", "WAITING", "COMPLETED", "FAILED", "CANCELED"]);
